import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { TEAMS_QUERY_KEY } from '../constants';
import { activateUser } from '../services';
import { ReactivateUserContext, ReactivateUserVariables, TeamListItem, UserStatuses } from '../types';
import { teamListCompare } from '../utils';

function useMutationReactivateUser(
  onSuccess: () => void,
  onError?: () => void,
): UseMutationResult<string, unknown, ReactivateUserVariables, ReactivateUserContext> {
  const queryClient = useQueryClient();

  const mutationFn = async (id: any): Promise<any> => {
    await activateUser(id);
  };

  const onSuccessFn = async (_data: string, id: ReactivateUserVariables, _context: ReactivateUserContext | undefined): Promise<void> => {
    queryClient.setQueryData([TEAMS_QUERY_KEY], (old: TeamListItem[] | undefined): TeamListItem[] | undefined => {
      if (old === undefined) {
        return [];
      }

      const oldData = [...old];

      const index = oldData.findIndex((t) => t.id === (id as unknown));

      oldData[index] = {
        ...oldData[index],
        status: UserStatuses.PROVISIONED,
      };

      oldData.sort(teamListCompare);

      return oldData;
    });
    onSuccess?.();
  };

  return useMutation<string, unknown, ReactivateUserVariables, ReactivateUserContext>(['reactivateUser'], mutationFn, {
    onError,
    onSuccess: onSuccessFn,
  });
}

export default useMutationReactivateUser;
